import React from 'react';
import { Info } from 'lucide-react';
import { useFormContext } from '../FormContext';
import { FormStep } from '../FormStep';
import { InfoBox } from '../InfoBox';
import { FormButtons } from '../FormButtons';
import { ProjectTypeSelector } from '../ProjectTypeSelector';
export const ProjectTypeStep: React.FC = () => {
  const {
    formData,
    handleProjectTypeToggle,
    goToPreviousStep,
    goToNextStep
  } = useFormContext();
  return <FormStep title="Wat wilt u laten plaatsen?" description="Selecteer één of meerdere opties die u interesseren. Meerdere keuzes mogelijk." isActive={true} data-id="element-1095">
      <ProjectTypeSelector selectedTypes={formData.projectTypes} onToggle={handleProjectTypeToggle} data-id="element-1096" />
      <InfoBox icon={<Info data-id="element-1098" />} data-id="element-1097">
        Kies minimaal één optie om door te gaan. U kunt meerdere opties
        selecteren als u geïnteresseerd bent in een combinatie.
      </InfoBox>
      <FormButtons onPrevious={goToPreviousStep} onNext={goToNextStep} isNextDisabled={formData.projectTypes.length === 0} data-id="element-1099" />
    </FormStep>;
};